import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import {
  cancelAllCardsSuccessAction,
  clearCardsToStoreAction,
  setHasUndefinedCardToStore,
  setNextCardPositionToStore,
} from 'data/reducers';
import { AllCardsCanceledResponse, Notifications } from 'types';

export function* allCardsCanceled({ type: notificationType }: AllCardsCanceledResponse) {
  try {
    if (notificationType === Notifications.ALL_CARDS_CANCELED) {
      yield put(cancelAllCardsSuccessAction());
      yield put(clearCardsToStoreAction());
      yield put(setHasUndefinedCardToStore(false));
      yield put(setNextCardPositionToStore(null));
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
